/* unplugin-vue-components disabled */import { render } from "./yujimap.vue?vue&type=template&id=463af4a8&scoped=true"
import script from "./yujimap.vue?vue&type=script&lang=js"
export * from "./yujimap.vue?vue&type=script&lang=js"

import "./yujimap.vue?vue&type=style&index=0&id=463af4a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463af4a8"]])

export default __exports__